import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { type ModernLearnerModule, TRAINING_QUERY_KEYS } from './trainingModuleApi'

export function useGetMyTrainingModules(programId?: string, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [TRAINING_QUERY_KEYS.learner, programId],
    queryFn: async () => {
      if (!programId || !enabled) throw new Error('Training program is not available')
      const { data } = await apiClient.get<ModernLearnerModule[]>(
        `/int/v3/operators/training-modules/mine?programId=${encodeURIComponent(programId)}`
      )
      return data
    },
    enabled: enabled && Boolean(programId),
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  })
}
